// src/routes/contentRoutes.js
// Small helper to keep App.js cleaner
import React from "react";
import { Navigate } from "react-router-dom";

// Lazy-loaded so ContentPage and its deps ship as an on-demand chunk. Rendered
// inside App's <Suspense> boundary.
const ContentPage = React.lazy(() => import("../pages/ContentPage"));

export const contentRoutes = [
  { path: "/content", element: <ContentPage /> },
  { path: "/content/new", element: <Navigate to="/content?wizard=new" replace /> },
];
